import src from "IMAGE";
export default { src, width: 411, height: 339, blurWidth: 0, blurHeight: 0};
